import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "image",
  "use": "image-usage",
  "viewBox": "0 0 19 15",
  "content": "<symbol viewBox=\"0 0 19 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"image\"><path d=\"M1.875 0h15a1.875 1.875 0 011.875 1.875v11.25A1.875 1.875 0 0116.875 15h-15A1.875 1.875 0 010 13.125V1.875A1.875 1.875 0 011.875 0zm13.381 5.625L17.5 7.862V1.875a.625.625 0 00-.625-.625h-15a.625.625 0 00-.625.625V12.8l3.513-4.013a1.25 1.25 0 011.718-.15l2.225 1.775 4.788-4.787a1.25 1.25 0 011.762 0zm-4.631-1.25a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol